import React from 'react';
import './Services.css';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';




const Services = () => {
  const navigate = useNavigate();
  const goToCotizaciones = () => 
    navigate('/cotizaciones');  
  const servicios = [
    {
      id: 1,
      titulo: "Mudanzas Locales",
      imagen: "/mudanzas-1.jpg",
      descripcion: "Servicio de mudanza dentro de la ciudad con personal capacitado y vehículos modernos. Incluye embalaje, carga, transporte y descarga.",
      caracteristicas: ["Embalaje profesional", "Transporte seguro", "Montaje de muebles", "Seguro incluido"]
    },
    {
      id: 2,
      titulo: "Mudanzas Nacionales",
      imagen: "/mudanzas-nacional.png",
      descripcion: "Mudanzas a nivel nacional con seguimiento en tiempo real y garantía de entrega. Cubrimos todo el territorio nacional.",
      caracteristicas: ["Seguimiento GPS", "Cobertura nacional", "Seguro completo", "Almacenamiento temporal"]
    },
    {
      id: 3,
      titulo: "Mudanzas Internacionales",
      imagen: "/internacional.png",
      descripcion: "Servicio completo de mudanza internacional con gestión de aduanas y documentación necesaria para el traslado de sus pertenencias.",
      caracteristicas: ["Gestión aduanera", "Documentación internacional", "Seguro internacional", "Almacenamiento en destino"]
    },
    {
      id: 4,
      titulo: "Embalaje Básico",
      imagen: "/embalaje.jpg",
      descripcion: "Servicio gratuito de embalaje básico para colchones y artículos simples.",
      caracteristicas: ["Embalaje de colchones", "Materiales básicos", "Sin costo adicional", "Protección básica"],
      precio: "Gratis"
    },
    {
      id: 5,
      titulo: "Embalaje Medio",
      imagen: "/embalaje-medio.jpg",
      descripcion: "Servicio de embalaje especializado para artículos valiosos y electrónicos.",
      caracteristicas: ["Embalaje de TV y electrónicos", "Materiales especializados", "Protección reforzada", "Inventario detallado"],
      precio: "Desde $50.000"
    },
    {
      id: 6,
      titulo: "Embalaje Premium",
      imagen: "/embalaje-premium.jpg",
      descripcion: "Servicio completo de embalaje para todos sus artículos con materiales premium y máxima protección.",
      caracteristicas: ["Embalaje completo", "Materiales premium", "Protección máxima", "Inventario detallado", "Supervisión profesional"],
      precio: "Desde $100.000"
    }
  ];

  return (
    <div className="services-container">
      <div className="services-header">
        <h1>Nuestros Servicios</h1>
        <p>Ofrecemos soluciones completas para tu mudanza, con la garantía de un servicio profesional y de calidad</p>
      </div>

      <div className="services-grid">
        {servicios.map((servicio) => (
          <div key={servicio.id} className="service-card">
            <div className="service-image">
              <img src={servicio.imagen} alt={servicio.titulo} />
            </div>
            <div className="service-content">
              <h2>{servicio.titulo}</h2>
              <p>{servicio.descripcion}</p>
              <ul className="service-features">
                {servicio.caracteristicas.map((caracteristica, index) => (
                  <li key={index}>
                    <span className="check-icon">✓</span>
                    {caracteristica}
                  </li>
                ))}
              </ul>
              {servicio.precio && (
                <div className="service-price">
                  <p className="price">{servicio.precio}</p>
                </div>
              )}
              <button onClick={goToCotizaciones} className="service-button">Solicitar Cotización</button>
            </div>
            
          </div>
        ))}
      </div>

      <div className="services-cta">
        <h2>¿Necesitas ayuda con tu mudanza?</h2>
        <p>Contáctanos para una cotización personalizada</p>
        <button className="cta-button">Contactar Ahora</button>
      </div>
    </div>
  );
};

export default Services;
